import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/common/basis/i18n/en.json';
import zh from '@/common/basis/i18n/zh.json';

// 初始化国际化
i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, zh: { translation: zh } },
  interpolation: { escapeValue: false },
});

export default i18n;
